module.exports = __webpack_public_path__ + "img/bandeau_T&T.9148a536.png";